import React from 'react'
import { IoCheckbox } from 'react-icons/io5'

const ListCard = ({array}) => {
    console.log(array)
  return (
    
    <>
        {
          array.map((item, index)=>{
                return (
                    <div>
                        
                        <img src={item?.icon} alt={item?.title} />
                        <h6>{item?.title}</h6>
                        <h3>{item?.header}</h3>
                        <h4>{item?.descrption}</h4>
                        <div className='points'>
                        <p><IoCheckbox color='#0072DB' /><span>{item?.list.item1}</span> </p>
                         <p><IoCheckbox color='#0072DB' /><span>{item?.list.item2}</span> </p>
                         <p><IoCheckbox color='#0072DB' /><span>{item?.list.item3}</span> </p>
                        </div>
                         

                    </div>
                )
            })

        }

      
    </>
  )
}

export default ListCard
